import {Component, OnInit, signal} from '@angular/core';
import {CodaltComponent} from '../../codalt.component';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';
import {Utils} from '../../utils.class';
import {Routenames} from '../../route-names.enum';
import {MoldMaterial} from '../../mold-material';
import {MoldService} from '../../services/mold.service';
import {VvrIconComponent} from "../../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {MatError, MatFormField, MatInput} from "@angular/material/input";
import {MatButton} from "@angular/material/button";

@Component({
    selector: 'app-mold-material-edit',
    templateUrl: './mold-material-edit.component.html',
    styleUrls: ['./mold-material-edit.component.scss'],
    imports: [
        VvrIconComponent,
        RouterLink,
        MatTooltip,
        ReactiveFormsModule,
        MatFormField,
        MatInput,
        MatError,
        MatButton
    ]
})
export class MoldMaterialEditComponent extends CodaltComponent implements OnInit {

    fc: {
        name: FormControl
    };

    readonly form = signal<FormGroup>(null);

    material: MoldMaterial;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private confirmDialog: ConfirmDialogService,
        private moldService: MoldService
    ) {
        super();
    }

    ngOnInit(): void {
        this.subscriptions.add(this.route.params.subscribe(params => {
            this.moldService.getMaterial(params['id']).subscribe(equipment => {
                this.material = equipment.data || new MoldMaterial();
                this.fc = {
                    name: new FormControl(this.material.name, Validators.required)
                };
                this.form.set(new FormGroup(this.fc));
            });
        }));
    }

    save() {
        Utils.triggerValidation(this.form());
        if (this.form().valid) {
            this.material.name = this.fc.name.value;
            this.moldService.saveMaterial(this.material).subscribe(() => {
                this.router.navigate([Routenames.moldMaterial]);
            }, error => {
                this.confirmDialog.confirm(
                    'Fout bij het opslaan',
                    error.message,
                    'Sluiten'
                ).then(() => {

                }, () => {

                });
            });
        }
    }
}
